import { Button, Grid, IconButton, Link, Typography } from '@mui/material';
import { Formik } from 'formik';
import { Link as RouterLink } from 'react-router-dom';
import * as Yup from 'yup';
import InputField from '../elements/InputField';
import { ArrowBack } from '@mui/icons-material';

const OrganizationForm = ({ handleSubmit, goBackToStepOne }) => {
  return (
    <Formik
      initialValues={{
        organization: '',
      }}
      validationSchema={Yup.object().shape({
        organization: Yup.string().max(255).required('This field is required'),
      })}
      onSubmit={async (values, { setErrors, setSubmitting }) => {
        try {
          await handleSubmit(values);
          setSubmitting(false);
        } catch (err) {
          console.error(err);
          setErrors({ submit: err.message });
          setSubmitting(false);
        }
      }}>
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <>
          <Grid item xs={12}>
            <Grid item xs={12}>
              <IconButton
                onClick={goBackToStepOne}
                disabled={isSubmitting}
                aria-label="back"
                sx={{ mb: 1 }}>
                <ArrowBack />
              </IconButton>
            </Grid>
            <Typography variant="h5" sx={{ mb: 2 }}>Organization Details</Typography>
          </Grid>
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InputField
                  label="Company/Organization Name"
                  id="organization"
                  type="organization"
                  value={values.organization}
                  name="organization"
                  fullWidth
                  placeholder="Company/Organization Name"
                  error={Boolean(touched.organization && errors.organization)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2">
                  By Signing up, you agree to our &nbsp;
                  <Link
                    variant="subtitle2"
                    target="_blank"
                    component={RouterLink}
                    to="https://www.gtentechnologies.com/termsandconditions/">
                    Terms of Service
                  </Link>
                  &nbsp; and &nbsp;
                  <Link
                    variant="subtitle2"
                    target="_blank"
                    component={RouterLink}
                    to="https://www.gtentechnologies.com/privacypolicy/">
                    Privacy Policy
                  </Link>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  disableElevation
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                  color="primary">
                  {isSubmitting ? 'Creating...' : 'Create Account'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </>
      )}
    </Formik>
  );
};

export default OrganizationForm;
